import AxiosClient from '../../../../../functional/Axios/AxiosClient';

export const widgetsAdminApi = {
  getWidgets: () => AxiosClient.get('/root/widgets'),

  registerWidget: ({ ...data }) => AxiosClient.post('/root/widgets', { ...data }),

  updateWidget: ({ ...data }) => AxiosClient.put('/root/widgets', { ...data })
};
